const useStyles = () => {
    return {
        commentInfo: {
            display: 'flex',
            flexDirection: 'column',
            flex: '1 0 200px'
        },
        comment: {
            display: 'flex',
            flexWrap: 'wrap',
            justifyContent: 'space-between',
            alignItems: 'start',
            gap: 2
        },
        addorment: {
            alignItems: 'start',
            position: 'relative',
            bottom: '-20px',
            right: '-10px'
        },
        answers: {
            width: '90%',
            margin: '0 auto',
            display: 'flex',
            flexDirection: 'column',
            gap: 2
        },
    }
}

export { useStyles }
